import type { Event } from '../../types';
import type { TicketClass } from './types';

type EventToCheck = Pick<
    Event,
    'compactCheckoutDisqualifications' | 'childEvents'
> & { salesStatus: string };

export const qualifiesForMultiticketSelection = (
    _event: EventToCheck,
    _ticketClasses: Array<TicketClass>,
    _hasBogoTickets?: boolean,
    _onlyDefaultCheckoutForOnlineEvents?: boolean,
) => {
    return false;
};
